"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var theme_1 = require("../../components/theme");
var mithril_1 = require("../../mithril");
var dashboard_table_style_1 = require("./dashboard.table.style");
(0, theme_1.addStyles)(dashboard_table_style_1.Style);
exports.Table = {
    view: function (title, header, rows) {
        var headerChildren = [];
        var i = 0;
        for (var _i = 0, header_1 = header; _i < header_1.length; _i++) {
            var colHeader = header_1[_i];
            headerChildren.push((0, mithril_1.m)('th', { className: "".concat(dashboard_table_style_1.CSS.MDL.cell, " ").concat(rows[0][i].attrs.className) }, colHeader));
            i++;
        }
        var bodyChildren = [];
        for (var _a = 0, rows_1 = rows; _a < rows_1.length; _a++) {
            var row = rows_1[_a];
            var rowChildren = [];
            for (var _b = 0, row_1 = row; _b < row_1.length; _b++) {
                var col = row_1[_b];
                rowChildren.push((0, mithril_1.m)('td', { className: "".concat(dashboard_table_style_1.CSS.cell, " ").concat(dashboard_table_style_1.CSS.MDL.cell, " ").concat(col.attrs.className) }, col));
            }
            bodyChildren.push((0, mithril_1.m)('tr', { className: dashboard_table_style_1.CSS.row }, rowChildren));
        }
        return (0, mithril_1.m)('div', { className: dashboard_table_style_1.CSS.container }, [
            (0, mithril_1.m)('div', { className: dashboard_table_style_1.CSS.title }, title),
            (0, mithril_1.m)('table', { className: "".concat(dashboard_table_style_1.CSS.body, " ").concat(dashboard_table_style_1.CSS.MDL.table) }, [
                (0, mithril_1.m)('thead', { className: dashboard_table_style_1.CSS.header }, headerChildren),
                (0, mithril_1.m)('tbody', bodyChildren)
            ])
        ]);
    }
};
//# sourceMappingURL=dashboard.table.js.map